export default {
  currentLog: null,
  unsolved: 0,
}
